import { JourneySegment } from './Journey.interfaces';
import {
    convertMillisecondsToTime,
    getDifferenceInMillisecond,
} from '@shared/helpers/datetime/datetime';

export function getStops(segments: JourneySegment[]) {
    if (segments.length <= 1) {
        return 0;
    }

    return segments.length - 1;
}

export function getTravelTime(from?: Date | null, to?: Date | null): string | null {
    if (from && to) {
        const ms = getDifferenceInMillisecond(to, from);
        return convertMillisecondsToTime(ms);
    }

    return null;
}

export function getFullTravelTime(segments: JourneySegment[]): string | null {
    const first = segments[0];
    const last = segments[segments.length - 1];

    return getTravelTime(first.departure.date, last.arrival.date);
}
